var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoStepsTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 358,
    viewBox: "0 0 16 358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5V352",
    stroke: "#DDDDDD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#F5F5F5",
    stroke: "#FF6A49",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 115.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#F5F5F5",
    stroke: "#FF6A49",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 229.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#F5F5F5",
    stroke: "#FF6A49",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 343.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#F5F5F5",
    stroke: "#FF6A49",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoStepsTimeline);
export default __webpack_public_path__ + "static/media/geo_steps_timeline.8b55d457190c0ef17260f6d8e33daec7.svg";
export { ForwardRef as ReactComponent };